import * as React from "react";
import { get, has } from "lodash";
// import { Link } from "react-router-dom";
import styled from "styled-components";

import { LinkDisplayTypes, LinkLayoutStyles } from "./types";

import Button from "../Button/live";
import ListItem from "../ListItem/live";
import { IconSource } from "../Icon/types";
import presets from "../Button/presets";
import { EditorMode } from "@/Apps/Pages/Editor/types";
import { parseLiquidString, parseLiquidStringWithLiquidJS } from "@/Apps/Pages/Page/LiquidRenderer";
import { useContext } from "react";
import { PageContext } from "@/Apps/Pages/Page/PageContext";

interface LinkProps {
  mode?: EditorMode;
  filter?: any;
  items: any[];
  linkStyle: any;
  showSocial?: boolean;
  style?: any;
  layoutStyle?: LinkLayoutStyles;
}

const Link = (props) => {
  const pageContext = useContext(PageContext);
  const href = parseLiquidStringWithLiquidJS(props?.href || "#", pageContext);
  return (
    <a {...props} href={href}>
      {props.children}
    </a>
  );
};

const LI = styled.div`
    &:hover {
      text-decoration: underline;
    }
  `;

export const Links: React.FC<LinkProps> = ({
  filter,
  items,
  linkStyle,
  showSocial,
  style,
  layoutStyle = LinkLayoutStyles.HORIZONTAL,
  mode = EditorMode.LIVE,
}) => {
  let links = items;
  if (filter) links = items.filter((itm) => itm.column === filter);

  // display: inline-block;  

  const OptionallyRenderAsLink = (props) => {
    if (mode === EditorMode.EDITOR) return props.children;
    return <Link {...props} />;
  };

  return (
    <div
      style={{
        display: layoutStyle === LinkLayoutStyles.HORIZONTAL ? "flex" : "table",
        ...style,
        // margin: "0 auto"
        // float: showSocial ? "none" : "right"
      }}
    >
      {links.map((itm, key) => {
        if (get(itm, "type", LinkDisplayTypes.TEXT) === LinkDisplayTypes.TEXT) {
          return (
            <OptionallyRenderAsLink
              key={key}
              href={itm.href || "#"}
              style={{ textDecoration: "none" }}
            >
              <LI
                style={{
                  ...linkStyle,
                  listStyle: "none",
                  display:
                    layoutStyle === LinkLayoutStyles.HORIZONTAL
                      ? "inline-block"
                      : "block",
                }}
              >
                {itm.caption}
              </LI>
            </OptionallyRenderAsLink>
          );
        }

        if (get(itm, "type") === LinkDisplayTypes.ICON) {
          return (
            <OptionallyRenderAsLink href={itm.href}
              key={key}
            >
              <ListItem
                style={{
                  listStyle: "none",
                  ...linkStyle,
                  ...get(itm, "style", {}),
                  display: layoutStyle === LinkLayoutStyles.HORIZONTAL
                    ? "inline-block"
                    : "block",
                }}
                containerStyle={{ display: 'inline-block' }}
                iconSource={get(itm, "iconSource", IconSource.MATERIAL)}
                iconStyle={get(itm, "iconStyle", { paddingRight: 7 })}
                icon={get(itm, "icon")}
                contentStyle={get(itm, "contentStyle", { textAlign: 'center' })}
              >
                {/* {get(itm, 'caption', '')} */}
              </ListItem>
            </OptionallyRenderAsLink>
          );
        }

        if (get(itm, "type") === LinkDisplayTypes.BUTTON) {
          return (
            <LI
              style={{
                listStyle: "none",
                display:
                  layoutStyle === LinkLayoutStyles.HORIZONTAL
                    ? "inline-block"
                    : "block",
                ...linkStyle,
              }}
              key={key}
            >
              <a href={itm.href || "#"}>
                <Button
                  caption1={itm.caption}
                  {...get(itm, "buttonSettings", {})}
                  {...(has(itm, "preset") ? presets[itm.preset] : {})}
                />
              </a>
            </LI>
          );
        }
      })}
      {/* {(mode === EditorMode.EDITOR) && <li style={{ position: 'relative' }} onClick={() => alert("Add Link!")}>(+)</li>} */}
    </div>
  );
};
